<header class="h-[70px] overflow-hidden hidden md:flex items-center bg-white relative z-1001 shadow-md shrink-0">
  @if (activeLogos(); as filteredLogos) {
    <!-- Centered static school logo(s) + Vantage logo -->
    <div class="flex items-center justify-center w-full h-full gap-8 lg:gap-14 animate-slide-down">
      @for (logo of filteredLogos; track $index) {
        <img [src]="logo" alt="School Logo" class="h-10 lg:h-12 w-auto object-contain transition-all hover:scale-105 duration-300" />
      }
    </div>
  } @else {
    <!-- Full scrolling carousel across all schools -->
    <div class="flex items-center h-full animate-scroll min-w-max">
      @for (logo of logos; track $index) {
        <img [src]="logo" alt="School Logo" class="h-10 lg:h-12 w-auto object-contain mx-6 lg:mx-10 transition-all" />
      }
    </div>
  }
</header>


<main class="flex-1 flex flex-col overflow-y-auto bg-bg-primary w-full relative min-h-0" cdkScrollable>
  <router-outlet></router-outlet>
</main>